import React from 'react';
const PrivacyCookiePage = () => {
  return <div className="bg-white" data-id="element-1615">
      <div className="container mx-auto px-4 py-12" data-id="element-1616">
        <h1 className="text-3xl md:text-4xl font-bold text-burgundy-600 mb-6" data-id="element-1617">
          Privacy & Cookie Policy
        </h1>
        <section className="mb-8" data-id="element-1618">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1619">
            1. Privacy Statement
          </h2>
          <p className="mb-4" data-id="element-1620">
            At <span className="text-burgundy-600" data-id="element-1621">N</span>orthampton{' '}
            <span className="text-burgundy-600" data-id="element-1622">D</span>riving{' '}
            <span className="text-burgundy-600" data-id="element-1623">S</span>chool, we are committed
            to protecting your privacy and handling your personal information
            responsibly, in line with the UK General Data Protection Regulation
            (GDPR) and the Data Protection Act 2018.
          </p>
          <p className="mb-4" data-id="element-1624">This policy explains:</p>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1625">
            <li data-id="element-1626">What information we collect</li>
            <li data-id="element-1627">How we use and protect it</li>
            <li data-id="element-1628">Your rights under data protection law</li>
          </ul>
          <p data-id="element-1629">
            When you use our website or services, you agree to the practices
            described in this policy.
          </p>
        </section>
        <section className="mb-8" data-id="element-1630">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1631">
            2. Information We Collect
          </h2>
          <p className="mb-4" data-id="element-1632">
            We may collect the following information when you contact us, book
            lessons, or use our website:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1633">
            <li data-id="element-1634">Name, address, email, and phone number</li>
            <li data-id="element-1635">
              Payment information (processed securely by third-party providers;
              we do not store card details)
            </li>
            <li data-id="element-1636">
              Enquiry details (such as preferred lesson times, location, or
              driving requirements)
            </li>
            <li data-id="element-1637">
              Technical data such as IP address, browser type, and device
              information
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1638">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1639">
            3. How We Use Your Data
          </h2>
          <p className="mb-4" data-id="element-1640">
            We process your personal data for the following purposes:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1641">
            <li data-id="element-1642">To deliver driving lessons and related services</li>
            <li data-id="element-1643">To manage bookings and payments</li>
            <li data-id="element-1644">
              To communicate with you (lesson reminders, updates, and support)
            </li>
            <li data-id="element-1645">To comply with legal and safety obligations</li>
            <li data-id="element-1646">To improve our website and customer experience</li>
          </ul>
          <p data-id="element-1647">
            We will never sell or share your personal data with third parties
            for marketing purposes. Limited information may be shared with
            trusted providers (such as payment processors or website hosting
            platforms) where required to deliver our services.
          </p>
        </section>
        <section className="mb-8" data-id="element-1648">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1649">
            4. Your Rights
          </h2>
          <p className="mb-4" data-id="element-1650">Under GDPR, you have the right to:</p>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1651">
            <li data-id="element-1652">Access the personal data we hold about you</li>
            <li data-id="element-1653">Request correction of inaccurate information</li>
            <li data-id="element-1654">
              Request deletion of your personal data (where legally permissible)
            </li>
            <li data-id="element-1655">Object to certain types of processing</li>
            <li data-id="element-1656">Withdraw consent for marketing communications</li>
          </ul>
          <p data-id="element-1657">
            To exercise these rights, please email us at
            info@northamptondrivingschool.co.uk.
          </p>
        </section>
        <section className="mb-8" data-id="element-1658">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1659">
            5. Cookie Policy
          </h2>
          <h3 className="text-xl font-bold text-burgundy-600 mb-3" data-id="element-1660">
            What Are Cookies?
          </h3>
          <p className="mb-4" data-id="element-1661">
            Cookies are small text files stored on your device when you visit
            our website. They help the site function properly, improve your
            browsing experience, and allow us to understand how our website is
            used.
          </p>
          <h3 className="text-xl font-bold text-burgundy-600 mb-3" data-id="element-1662">
            Types of Cookies We Use
          </h3>
          <h4 className="text-lg font-bold text-burgundy-600 mb-2" data-id="element-1663">
            a. Strictly Necessary Cookies
          </h4>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1664">
            <li data-id="element-1665">Essential for the website to function.</li>
            <li data-id="element-1666">
              Used for actions like logging in, securing the site, and
              processing forms.
            </li>
            <li data-id="element-1667">Without them, some services may not work properly.</li>
          </ul>
          <h4 className="text-lg font-bold text-burgundy-600 mb-2" data-id="element-1668">
            b. Functional Cookies
          </h4>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1669">
            <li data-id="element-1670">
              Allow us to remember your preferences (e.g., region, language).
            </li>
            <li data-id="element-1671">Provide enhanced functionality and personalisation.</li>
            <li data-id="element-1672">If disabled, some features may not operate as intended.</li>
          </ul>
          <h4 className="text-lg font-bold text-burgundy-600 mb-2" data-id="element-1673">
            c. Performance Cookies
          </h4>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1674">
            <li data-id="element-1675">
              Collect anonymous information about how visitors use the website.
            </li>
            <li data-id="element-1676">
              Help us understand which pages are most popular and where
              improvements are needed.
            </li>
            <li data-id="element-1677">Data is aggregated and does not personally identify you.</li>
          </ul>
          <h4 className="text-lg font-bold text-burgundy-600 mb-2" data-id="element-1678">
            d. Targeting & Advertising Cookies
          </h4>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1679">
            <li data-id="element-1680">
              Used to deliver adverts that are more relevant to you and your
              interests.
            </li>
            <li data-id="element-1681">May be set by us or advertising partners.</li>
            <li data-id="element-1682">
              Track browsing activity across websites (with your consent).
            </li>
            <li data-id="element-1683">
              If disabled, you will still see adverts, but they may be less
              relevant.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1684">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1685">
            6. Managing Your Cookies
          </h2>
          <p className="mb-4" data-id="element-1686">
            You can manage or disable cookies at any time through your browser
            settings. However, some features of our website may not function
            correctly without them.
          </p>
          <p className="mb-4" data-id="element-1687">For more control, you can:</p>
          <ul className="list-disc pl-6 mb-4 space-y-1" data-id="element-1688">
            <li data-id="element-1689">
              Adjust cookie preferences through our cookie banner (when visiting
              our site).
            </li>
            <li data-id="element-1690">Clear cookies in your browser history.</li>
            <li data-id="element-1691">
              Opt out of personalised advertising via industry tools such as
              www.youronlinechoices.com.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1692">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1693">
            7. Data Retention
          </h2>
          <p data-id="element-1694">
            We only keep personal data for as long as necessary to provide our
            services and meet legal obligations. Lesson and payment records may
            be kept for up to six years in line with tax and accounting
            requirements.
          </p>
        </section>
        <section className="mb-8" data-id="element-1695">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1696">
            8. Changes to This Policy
          </h2>
          <p data-id="element-1697">
            We may update this Privacy & Cookie Policy from time to time.
            Updates will be published on this page with a new "last updated"
            date. Continued use of our website means you accept the updated
            policy.
          </p>
        </section>
        <section className="mb-8" data-id="element-1698">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1699">
            9. Contact Us
          </h2>
          <p className="mb-4" data-id="element-1700">
            If you have any questions about this Privacy & Cookie Policy or how
            we handle your data, please contact:
          </p>
          <p className="flex items-center space-x-2 mb-1" data-id="element-1701">
            <span className="text-burgundy-600" data-id="element-1702">📧</span>
            <a href="mailto:info@northamptondrivingschool.co.uk" className="text-burgundy-600 hover:text-burgundy-800" data-id="element-1703">
              info@northamptondrivingschool.co.uk
            </a>
          </p>
          <p className="flex items-center space-x-2 mb-1" data-id="element-1704">
            <span className="text-burgundy-600" data-id="element-1705">📞</span>
            <a href="tel:07481300600" className="text-burgundy-600 hover:text-burgundy-800" data-id="element-1706">
              07481 300 600
            </a>
          </p>
          <p className="flex items-center space-x-2" data-id="element-1707">
            <span className="text-burgundy-600" data-id="element-1708">📍</span>
            <span data-id="element-1709">Northampton Driving School, Northampton, UK</span>
          </p>
        </section>
      </div>
    </div>;
};
export default PrivacyCookiePage;